import React from 'react';

import { PositionTrainingMatrixFilters } from '@/state/PositionTrainingMatrixFilter.atom';
import { RegulatoryIndicators } from '@/types/Training';

import Cards from './Cards';
import ExpandableSubtitle from './ExpandableSubtitle';

interface RegulatoryTrainingIndicatorsProps {
	indicators: RegulatoryIndicators | undefined;
	isPositionFilteringIndicator: boolean;
	isTrainingFilteringIndicator: boolean;
	setIsPositionFilteringIndicator: React.Dispatch<
		React.SetStateAction<boolean>
	>;
	setIsTrainingFilteringIndicator: React.Dispatch<
		React.SetStateAction<boolean>
	>;
	handleMatrixRefetch: () => Promise<void>;
}

export const RegulatoryTrainingIndicators = ({
	indicators,
	isPositionFilteringIndicator,
	isTrainingFilteringIndicator,
	setIsPositionFilteringIndicator,
	setIsTrainingFilteringIndicator,
	handleMatrixRefetch,
}: RegulatoryTrainingIndicatorsProps) => {
	const handleClickPositionsPendencies = async () => {
		if (indicators?.unmappedPositions) {
			if (isPositionFilteringIndicator) {
				setIsPositionFilteringIndicator(false);
				handleMatrixRefetch();
			} else {
				setIsPositionFilteringIndicator(true);
				setIsTrainingFilteringIndicator(false);
				handleMatrixRefetch();
			}
			return;
		}

		if (indicators?.unmappedPositions == 0 && isPositionFilteringIndicator) {
			setIsPositionFilteringIndicator(false);
			handleMatrixRefetch();
		}
	};

	const handleClickTrainingsPendencies = async () => {
		if (indicators?.unmappedTrainings) {
			if (isTrainingFilteringIndicator) {
				setIsTrainingFilteringIndicator(false);
				handleMatrixRefetch();
			} else {
				setIsTrainingFilteringIndicator(true);
				setIsPositionFilteringIndicator(false);
				handleMatrixRefetch();
			}
		}

		if (indicators?.unmappedTrainings == 0 && isTrainingFilteringIndicator) {
			setIsTrainingFilteringIndicator(false);
			handleMatrixRefetch();
		}
	};

	if (!indicators) return null;

	return (
		<div className="w-[92vw] pt-4">
			<ExpandableSubtitle subtitle={'Indicadores'}>
				<Cards
					cards={[
						{
							value: indicators.totalTrainings,
							status: 'green',
							title: 'Treinamentos Cadastrados',
							width: '16rem',
						},
						{
							value: indicators.unmappedPositions,
							status: 'red',
							title: 'Funções não mapeadas',
							onClick:
								isPositionFilteringIndicator ||
								indicators?.unmappedPositions > 0
									? handleClickPositionsPendencies
									: undefined,
							width: '16rem',
							borderColor: isPositionFilteringIndicator ? 'red' : undefined,
						},
						{
							value: indicators.unmappedTrainings,
							status: 'red',
							title: 'Treinamentos não mapeados',
							onClick:
								isTrainingFilteringIndicator ||
								indicators?.unmappedTrainings > 0
									? handleClickTrainingsPendencies
									: undefined,
							width: '16rem',
							borderColor: isTrainingFilteringIndicator ? 'red' : undefined,
						},
					]}
				/>
			</ExpandableSubtitle>
		</div>
	);
};
